import actCodes from './constants';

export const endTimeIsRequiredForCode = (code) => actCodes.includes(code);

export default endTimeIsRequiredForCode;
